const buttonWrapper = document.querySelector('.paymentButtonsWrapper');

if (buttonWrapper) {
  const container = buttonWrapper.closest('.shopify-section');
  if (container) {
    container.classList.add('productWrapper');
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        entry.target.classList.toggle(
          'inViewport',
          entry.isIntersecting
        );
      });
    },
    {
      threshold: 0 // sobald 1px sichtbar
    }
  );

  observer.observe(buttonWrapper);
}
